module.exports = __webpack_public_path__ + "static/media/doc.78da7c32.png";